export enum HealthDiaryPathsEnum {
  ROOT = "health-diary",
  WEIGHT = "weight",
  WAIST_CIRCUMFERENCE_LOG = "waist-circumference-log",
  WEIGHT_LOG = "weight-log",
  WEIGHT_HISTORY = "weight-history",
  PSA = "psa",
  PSA_LOG = "psa-log",
  PSA_HISTORY = "psa-history",
  WAIST_CIRCUMFERENCE = "waist-circumference",
  WAIST_CIRCUMFERENCE_HISTORY = "waist-circumference-history",
  BLOOD_PRESSURE = "blood-pressure",
  BLOOD_PRESSURE_LOG = "blood-pressure-log",
  BLOOD_PRESSURE_HISTORY = "blood-pressure-history",
  BLOOD_GLUCOSE = "blood-glucose-level",
  BLOOD_GLUCOSE_LOG = "blood-glucose-level-log",
  BLOOD_GLUCOSE_HISTORY = "blood-glucose-level-history",
  CHOLESTEROL = "cholesterol",
  CHOLESTEROL_LOG = "cholesterol-log",
  CHOLESTEROL_HISTORY = "cholesterol-history",
  EXERCISE = "exercise",
  EXERCISE_HISTORY = "exercise-history",
  PREGNANCY = "pregnancy",
  HBA1C = "hba1c-input",
  HBA1C_LOG = "hba1c-input-log",
  HBA1C_HISTORY = "hba1c-input-history",
  BMI = "bmi",
  BMI_HISTORY = "bmi-history",
  HEIGHT = "height",
  TEMPERATURE = "temperature",
  TEMPERATURE_LOG = "temperature-log",
  TEMPERATURE_HISTORY = "temperature-history",
  HEART_RATE = "heart-rate",
  STEPS = "steps",
  HEART_RATE_LOG = "heart-rate-log",
  STEPS_LOG = "steps-log",
  HEART_RATE_HISTORY = "heart-rate-history",
  HEIGHT_LOG = "height-log",
  HEIGHT_HISTORY = "height-history",
  STEPS_HISTORY = "steps-history",
  RESPIRATION = "respiration",
  RESPIRATION_LOG = "respiration-log",
  RESPIRATION_HISTORY = "respiration-history",
  BLOOD_OXYGEN = "blood-oxygen",
  BLOOD_OXYGEN_LOG = "blood-oxygen-log",
  BLOOD_OXYGEN_HISTORY = "blood-oxygen-history",
  HRV = "hrv",
  HRV_LOG = "hrv-log",
  HRV_HISTORY = "hrv-history",
  SLEEP = "sleep",
  SLEEP_LOG = "sleep-log",
  SLEEP_HISTORY = "sleep-history",
  STRESS = "stress",
  STRESS_LOG = "stress-log",
  STRESS_HISTORY = "stress-history",
}

export enum HealthDiaryRoutesEnum {
  ROOT = "/health-diary",
  HEALTH_DIARY_BLOOD_GLUCOSE = "/health-diary/blood-glucose-level",
  HEALTH_DIARY_BLOOD_GLUCOSE_HISTORY = "/health-diary/blood-glucose-level-history",
  HEALTH_DIARY_BLOOD_GLUCOSE_LOG = "/health-diary/blood-glucose-level-log",
  HEALTH_DIARY_CHOLESTEROL = "/health-diary/cholesterol",
  HEALTH_DIARY_CHOLESTEROL_LOG = "/health-diary/cholesterol-log",
  HEALTH_DIARY_CHOLESTEROL_HISTORY = "/health-diary/cholesterol-history",
  HEALTH_DIARY_EXERCISE = "/health-diary/exercise",
  HEALTH_DIARY_EXERCISE_HISTORY = "/health-diary/exercise-history",
  HEALTH_DIARY_WEIGHT = "/health-diary/weight",
  HEALTH_DIARY_WEIGHT_LOG = "/health-diary/weight-log",
  HEALTH_DIARY_WEIGHT_HISTORY = "/health-diary/weight-history",
  HEALTH_DIARY_PSA = "/health-diary/psa",
  HEALTH_DIARY_PSA_LOG = "/health-diary/psa-log",
  HEALTH_DIARY_PSA_HISTORY = "/health-diary/psa-history",
  HEALTH_DIARY_HEIGHT_LOG = "/health-diary/height-log",
  HEALTH_DIARY_HEIGHT_HISTORY = "/health-diary/height-history",
  HEALTH_DIARY_WAIST_CIRCUMFERENCE = "/health-diary/waist-circumference",
  HEALTH_DIARY_WAIST_CIRCUMFERENCE_LOG = "/health-diary/waist-circumference-log",
  HEALTH_DIARY_WAIST_CIRCUMFERENCE_HISTORY = "/health-diary/waist-circumference-history",
  HEALTH_DIARY_BLOOD_PRESSURE = "/health-diary/blood-pressure",
  HEALTH_DIARY_BLOOD_PRESSURE_LOG = "/health-diary/blood-pressure-log",
  HEALTH_DIARY_BLOOD_PRESSURE_HISTORY = "/health-diary/blood-pressure-history",
  HEALTH_DIARY_HBA1c_INPUT = "/health-diary/hba1c-input",
  HEALTH_DIARY_HBA1c_INPUT_LOG = "/health-diary/hba1c-input-log",
  HEALTH_DIARY_HBA1c_INPUT_HISTORY = "/health-diary/hba1c-input-history",
  HEALTH_DIARY_PREGNANCY = "/health-diary/pregnancy",
  HEALTH_DIARY_BMI = "/health-diary/bmi",
  HEALTH_DIARY_TEMPERATURE = "/health-diary/temperature",
  HEALTH_DIARY_TEMPERATURE_LOG = "/health-diary/temperature-log",
  HEALTH_DIARY_TEMPERATURE_HISTORY = "/health-diary/temperature-history",
  HEALTH_DIARY_RESPIRATION = "/health-diary/respiration",
  HEALTH_DIARY_RESPIRATION_LOG = "/health-diary/respiration-log",
  HEALTH_DIARY_RESPIRATION_HISTORY = "/health-diary/respiration-history",
  HEALTH_DIARY_BLOOD_OXYGEN = "/health-diary/blood-oxygen",
  HEALTH_DIARY_BLOOD_OXYGEN_LOG = "/health-diary/blood-oxygen-log",
  HEALTH_DIARY_BLOOD_OXYGEN_HISTORY = "/health-diary/blood-oxygen-history",
  HEALTH_DIARY_HRV = "/health-diary/hrv",
  HEALTH_DIARY_HRV_LOG = "/health-diary/hrv-log",
  HEALTH_DIARY_HRV_HISTORY = "/health-diary/hrv-history",
  HEALTH_DIARY_SLEEP = "/health-diary/sleep",
  HEALTH_DIARY_SLEEP_LOG = "/health-diary/sleep-log",
  HEALTH_DIARY_SLEEP_HISTORY = "/health-diary/sleep-history",
  HEALTH_DIARY_HEART_RATE = "/health-diary/heart-rate",
  HEALTH_DIARY_STEPS = "/health-diary/steps",
  HEALTH_DIARY_HEART_RATE_LOG = "/health-diary/heart-rate-log",
  HEALTH_DIARY_STEPS_LOG = "/health-diary/steps-log",
  HEALTH_DIARY_HEART_RATE_HISTORY = "/health-diary/heart-rate-history",
  HEALTH_DIARY_STEPS_HISTORY = "/health-diary/steps-history",
  HEALTH_DIARY_HEIGHT = "/health-diary/height",
  HEALTH_DIARY_STRESS = "/health-diary/stress",
  HEALTH_DIARY_STRESS_LOG = "/health-diary/stress-log",
  HEALTH_DIARY_STRESS_HISTORY = "/health-diary/stress-history",
}
